import { Box, Image } from "@chakra-ui/react";
import { FC } from "react";
import useScreen from "../../hooks/useScreen";
import { HairTipsCarousel } from "../HairTipsCarousel/HairTipsCarousel";

interface SmallLoader {
  vto: string;
}

export const SmallLoader: FC<SmallLoader> = (props) => {
  const { isMobile } = useScreen();

  return (
    <Box
      flexDirection="column"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgImage={process.env.PUBLIC_URL + "/assets/images/texture-ultafetti.png"}
      bgSize="cover"
      bgColor="#FFF5EB"
      w="full"
      minH={isMobile ? "300px" : "567px"}
      position="relative"
      gap={{ base: "20px", md: "48px" }}
    >
      <Image
        src={process.env.PUBLIC_URL + "/assets/images/spray.gif"}
        h={{ base: "50px", md: "80px" }}
      />

      <Box w="100%">
        <HairTipsCarousel place="small-loader" {...props} />
      </Box>
    </Box>
  );
};
